<template>
  <b-row align-h="center">
    <b-col sm="12" md="10" lg="8" xl="6">
      <b-card class="mb-2 form-card">
        <template #header class="card-header">
          <span class="small-link">
            <a href="/ressources/entreprise/guide-inscription.mp4" target="_blank">Guide Vidéo</a>
            <!-- | <a href="/ressources/entreprise/guide.pdf" target="_blank">Guide PDF</a> -->
          </span>
          <h4 class="my-2">Inscription Entreprise</h4>
        </template>

        <b-card-body>

          <!-- Login form -->
          <b-form v-if="step === 'login'" @submit.prevent="login">
            <b-row>
              <b-col sm="12">
                <b-form-group label="Civilité" class="mb-3">
                  <b-form-radio-group
                    v-model="form.civilite"
                    :options="civiliteOptions"
                    required
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row>
              <b-col sm="6">
                <!-- <b-form-input :value="pm.raisonSociale" placeholder="Nom de la société*" disabled /> -->
                <b-form-group label="Prénom" class="mb-3">
                  <b-form-input
                    v-model="form.prenom"
                    type="text"
                    placeholder="Jean"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Nom" class="mb-3">
                  <b-form-input
                    v-model="form.nom"
                    type="text"
                    placeholder="Dupont"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Adresse email" class="mb-3">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder="jean.dupont@example.org"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-checkbox class="mb-2" name="cgu" required>
              J'accepte les <a href="#" @click.prevent="showTermsModal">Conditions Générales d'Utilisation</a>
            </b-form-checkbox>

            <b-button type="submit" variant="primary">Connexion</b-button>
          </b-form>

          <!-- OTP -->
          <b-form v-else-if="step === 'otp'" @submit.prevent="validateOtp">
            <h4 class="text-center">
              Veuillez saisir le code de sécurité envoyé à l'adresse <strong>{{ form.email }}</strong>
            </h4>
            <div class="mx-auto mb-2" style="max-width: 300px;">
              <input
                type="text"
                class="form-control"
                v-model="form.otp"
                placeholder="Code de sécurité"
                disabled
              />
              <CodeKeyboard @pressed="form.otp = $event" :selfValue="form.otp" />
            </div>
            <b-button type="submit" variant="primary" class="d-block mt-4 mx-auto">Valider</b-button>
          </b-form>
        </b-card-body>
      </b-card>
    </b-col>

    <!-- Modal pour les CGU -->
    <TermsModal modalId="entreprise-terms-modal" />
  </b-row>
</template>

<script>
import CodeKeyboard from "@/components/CodeKeyboard"
import TermsModal from "@/components/TermsModal"
import axios from "@axios"
import useJwt from "@/auth/jwt/useJwt"

export default {
  name: 'EntrepriseLogin',
  components: {
    CodeKeyboard,
    TermsModal,
  },
  data() {
    return {
      form: {
        civilite: "",
        prenom: "",
        nom: "",
        email: "",
        otp: "",
      },
      step: "login",
      civiliteOptions: [
        { value: 'M', text: 'Monsieur' },
        { value: 'MME', text: 'Madame' },
        { value: 'NB', text: 'Non-binaire' }
      ]
    }
  },
  mounted() {
    useJwt.deleteToken()
    useJwt.deleteRefreshToken()
  },
  methods: {
    showTermsModal() {
      this.$bvModal.show('entreprise-terms-modal')
    },
    login() {
      axios
        .post('/auth/login', {
          civilite: this.form.civilite,
          prenom: this.form.prenom,
          nom: this.form.nom,
          email: this.form.email,
          typeInscription: "entreprise",
        })
        .then(() => {
          this.step = "otp";
          this.$toast.open({
            message: 'Votre code vous a été envoyé par email',
            type: 'success',
          });
          useJwt.setUserData({
            civilite: this.form.civilite,
            prenom: this.form.prenom.toUpperCase(),
            nom: this.form.nom.toUpperCase(),
            email: this.form.email.toLowerCase(),
          });
        })
        .catch(err => {
          console.error(err);
        })
    },
    validateOtp() {
      axios
        .post('/auth/otp', {
          civilite: this.form.civilite,
          prenom: this.form.prenom,
          nom: this.form.nom,
          email: this.form.email,
          otp: this.form.otp
        })
        .then(({ data }) => {
          console.log(data);
          useJwt.setToken(data.tokens.access.token)
          useJwt.setRefreshToken(data.tokens.refresh.token)
          this.$router.push({ name: 'entreprisePreRegistration' })
        })
        .catch(err => {
          console.error(err);
        })
    },
  },
}
</script>